import styled from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsHeading } from "src/components/Paradise/ParadiseDetailsHeading"
import { ParadiseProductImageThumbnail } from "src/components/Paradise/ParadiseProductImageThumbnail"
import { TParadiseShippableProduct } from "src/data/paradise/paradiseShippableProducts/paradiseShippableProductsTypes"

export function ParadiseShippableProductsDetailsMeta({
  shippableProduct,
}: {
  shippableProduct: TParadiseShippableProduct
}) {
  return (
    <div>
      <TitleWrapper>
        <ParadiseProductImageThumbnail
          imageUrl={shippableProduct.image_url ?? ""}
          width="70px"
        />

        <div>
          <ParadiseDetailsHeading>
            {shippableProduct.name}
          </ParadiseDetailsHeading>
          <Text variant="bodyS" color="secondary" as="span">
            {shippableProduct.product_id}
          </Text>
        </div>
      </TitleWrapper>
    </div>
  )
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.S};
`
